import { bool, element, func, number, node, string, oneOfType, arrayOf } from 'prop-types';
import React from 'react';
import {
  Container,
  FootLight,
  FootThick,
  FootWrapper,
  Title,
  TitleWrapper,
  TitleRightContent,
  WrapperContent,
} from './styles';

function Section({ title, fontSize, children, rightContent }) {
  return (
    <Container>
      <WrapperContent>
        <TitleWrapper>
          <Title fontSize={fontSize}>{title}</Title>
          {rightContent && <TitleRightContent>{rightContent}</TitleRightContent>}
        </TitleWrapper>
        <FootWrapper>
          <FootThick />
          <FootLight />
        </FootWrapper>
        {children}
      </WrapperContent>
    </Container>
  );
}

export default Section;
Section.propTypes = {
  title: string,
  isShown: bool,
  setIsShown: func,
  fontSize: number,
  children: oneOfType([element, arrayOf(node), node]),
  rightContent: node,
};

Section.defaultProps = {
  title: '',
  isShown: true,
  children: null,
  fontSize: null,
  setIsShown: () => {},
  rightContent: null,
};
